import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { get, post } from "../../Services/ApiHandler";
import { URL } from "../../Services/Constant";

const InApp = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [appVersion, setAppVersion] = useState("");
  const [iosAppVersion, setIosAppVersion] = useState("");

  const [review, setReview] = useState({
    android: false,
    ios: false,
  });

  const getPermissionsList = async () => {
    get(URL.APP_VERSION_LIST)
      .then((res) => {
        if (res?.status == "success") {
          const android = res?.data?.find((item) => item?.type === 1);
          const ios = res?.data?.find((item) => item?.type === 2);

          if (android && ios) {
            setAppVersion(android?.setting_value || "");
            setIosAppVersion(ios?.setting_value || "");

            setReview({
              android: android?.inreview,
              ios: ios?.inreview,
            });
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const Add = async (type) => {
    if (type == 1 ? !appVersion.trim() : !iosAppVersion.trim()) {
      toast.error(`please Enter ${type == 1 ? "Android" : "Ios"} App Version`);
      return;
    }
    const formdata = new FormData();
    formdata.append("setting_value", type === 1 ? appVersion : iosAppVersion);
    formdata.append("type", type);
    formdata.append("inreview", type === 1 ? review.android : review.ios);
    post(URL.APP_VERSION_ADD, formdata)
      .then((res) => {
        if (res?.status == "success") {
          toast.success(res?.message);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getPermissionsList();
  }, []);

  // console.log("review", review);

  return (
    <div className="dashRightView">
      <div className="d-flex ac-jc">
        <div className="col-md-6">
          <div className="d-flex ac-jb">
            <div className="col-md-8">
              <div className="d-flex gap-4">
                <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
                  Android App Version<span className="text-danger">*</span>
                </p>
                <div className="d-flex gap-1">
                  <input
                    type="checkbox"
                    className="input-box mb-1"
                    style={{
                      accentColor: "#852e59",
                    }}
                    value={review.android}
                    onChange={() =>
                      setReview((prev) => ({
                        ...prev,
                        android: !prev.android,
                      }))
                    }
                  />
                  <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary text-nowrap">
                    In Review
                  </p>
                </div>
              </div>
              <input
                className="input-box"
                name="app_version"
                value={appVersion}
                onChange={(e) => setAppVersion(e.target.value)}
                type="text"
                placeholder="App Version"
              />
            </div>
          </div>
          <div className="d-flex ac-jb">
            <button
              onClick={() => {
                Add(1);
              }}
              className="add-btn white f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
            >
              {loader && (
                <div
                  class="spinner-border spinner-border-sm "
                  role="status"
                  style={{ marginRight: "5px" }}
                />
              )}
              Update
            </button>
          </div>
        </div>

        <div className="col-md-6">
          <div className="d-flex ac-jb">
            <div className="col-md-8">
              <div className="d-flex gap-4">
                <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
                  Ios App Version<span className="text-danger">*</span>
                </p>
                <div className="d-flex gap-1">
                  <input
                    type="checkbox"
                    className="input-box mb-1"
                    style={{
                      accentColor: "#852e59",
                    }}
                    value={review.ios}
                    onChange={() =>
                      setReview((prev) => ({
                        ...prev,
                        ios: !prev.ios,
                      }))
                    }
                  />
                  <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary text-nowrap">
                    In Review
                  </p>
                </div>
              </div>
              <input
                className="input-box"
                name="app_version"
                value={iosAppVersion}
                onChange={(e) => setIosAppVersion(e.target.value)}
                type="text"
                placeholder="App Version"
              />
            </div>
          </div>
          <div className="d-flex ac-jb">
            <button
              onClick={() => {
                Add(2);
              }}
              className="add-btn white f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
            >
              {loader && (
                <div
                  class="spinner-border spinner-border-sm "
                  role="status"
                  style={{ marginRight: "5px" }}
                />
              )}
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InApp;
